import { groupBy } from 'lib/arrayUtils'

export function groupByOfferId(packages: App.Package[]): { [offerId: string]: App.Package[] } {
  return Object.fromEntries(groupBy(packages, (p) => p.offerId).entries())
}
